import { render, staticRenderFns } from "./LmButtonV2.vue?vue&type=template&id=0ab99c7d&scoped=true&"
import script from "./LmButtonV2.vue?vue&type=script&lang=js&"
export * from "./LmButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./LmButtonV2.vue?vue&type=style&index=0&id=0ab99c7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab99c7d",
  null
  
)

export default component.exports